<div [ngClass]="{'darkMode': darkModeService.darkMode}" class="confirm">
  <p>{{ ("GLOBAL_USERS_ADMIN.SURE_UPDATE"  | translate) }}</p>

  <button mat-raised-button color="secondary" (click)="confirmGlobalAdmins()" type="button">
    {{ ("GLOBAL_USERS_ADMIN.UPDATE"  | translate) }}
  </button>

</div> 